import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, createCommentVNode, createBlock, withCtx, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = { class: "nav-legal" };
const _hoisted_2 = { class: "nav-legal__list" };
const _hoisted_3 = { class: "nav-legal__list-item" };
const _hoisted_4 = {
  key: 0,
  class: "nav-legal__list-item is-separator",
  "aria-hidden": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavLegal",
  props: {
    items: {}
  },
  setup(__props) {
    const props = __props;
    const insertSeparator = (index) => {
      const halfItemsCount = Math.round(props.items.length / 2);
      return halfItemsCount >= 3 && halfItemsCount === index + 1;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (navItem, index) => {
            return openBlock(), createElementBlock(Fragment, {
              key: navItem.text
            }, [
              createElementVNode("li", _hoisted_3, [
                navItem.link && navItem.link.uri ? (openBlock(), createBlock(_sfc_main$1, {
                  key: 0,
                  uri: navItem.link.uri,
                  rel: navItem.link.rel,
                  target: navItem.link.target,
                  class: "nav-legal__link"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(navItem.text), 1)
                  ]),
                  _: 2
                }, 1032, ["uri", "rel", "target"])) : createCommentVNode("", true)
              ]),
              insertSeparator(index) ? (openBlock(), createElementBlock("li", _hoisted_4)) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
